import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import ProductListPrice from 'JS/catalog/components/product-list/price/ProductListPrice.vue';
import ProductSwatches from 'JS/catalog/components/product-list/swatches/ProductSwatches.vue';
import ReviewStars from '../../components/ReviewStars.vue';
import { computed } from 'vue';
import { IPdpSimilarProduct } from 'JS/types/PDP';
import { PDPRootState } from 'JS/pdp/state/types';
import { useLegacyVuexStore } from 'JS/composables/legacy-vuex-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareSimilarProductCard',
  props: {
    product: null,
    isFirstItem: { type: Boolean },
    isLastItem: { type: Boolean },
    showSwatchColumn: { type: Boolean },
    showRatingColumn: { type: Boolean }
  },
  emits: ["track-click", "add-to-cart"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'track-click', e: MouseEvent): void;
	(event: 'add-to-cart'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	product: IPdpSimilarProduct,
	isFirstItem?: boolean,
	isLastItem?: boolean,
	showSwatchColumn: boolean,
	showRatingColumn: boolean,
}





const store = useLegacyVuexStore<PDPRootState>();


const showAddToCartButton = computed<boolean>(() => {
	if ( !props.isFirstItem
		|| store.state.disableAddToCartButton
		|| store.getters.isShippingDisabled
		|| !store.getters.hasSelectedVariant
	) {
		return false;
	}

	return true;
});

const addingToCart = computed(() => {
	return store.state.addingToCart;
});


function removePriceText(price) {
	return { ...price, pricePromoText: null, hideWasPrice: true };
}


return { __sfc: true,props, emit, store, showAddToCartButton, addingToCart, removePriceText, BButton, ProductListPrice, ProductSwatches, ReviewStars }
}

})